var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCurved = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.109 5.967a3.25 3.25 0 0 0-4.048 1.59l-.78 1.558a4.75 4.75 0 0 1-5.916 2.323l-.628-.236a.75.75 0 0 1 .527-1.404l.628.235a3.25 3.25 0 0 0 4.048-1.59l.779-1.558a4.75 4.75 0 0 1 5.916-2.323l.629.236a.75.75 0 1 1-.527 1.404l-.628-.235z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCurved);
export default ForwardRef;